



















































import { PropType, defineComponent, onMounted, ref, useFetch, useRoute } from '@nuxtjs/composition-api';
import { SfButton, SfDropdown, SfList, SfSearchBar } from '@storefront-ui/vue';
import { debounce } from 'lodash-es';
import SvgImage from '~/components/General/SvgImage.vue';
import { useApi } from '~/composables';
import clinicsBasicInfoGql from '~/modules/clinics/queries/clinicsBasicInfo.gql';
import { ClinicsQuery } from '~/modules/clinics/types';

export default defineComponent({
  name: 'AnalysisAvailableClinics',
  components: {
    SfDropdown,
    SfButton,
    SfList,
    SfSearchBar,
    SvgImage,
  },
  props: {
    availableInAllClinics: {
      type: Boolean,
    },
    clinics: {
      type: Array as PropType<string[]>,
    },
  },
  setup(props) {
    const route = useRoute();
    const { query } = useApi();
    const isDropdownOpen = ref(false);
    const searchInput = ref('');
    const displayedClinics = ref<string[]>(props.clinics);

    useFetch(() => {
      if (route.value.hash === '#available-labs') {
        isDropdownOpen.value = true;
      }
    });

    onMounted(() => {
      const { hash } = route.value;
      if (!hash) return;
      const selectedElement = document.querySelector(hash);
      const rect = selectedElement.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // Calculate the position to scroll to (element's top position)
      const targetPosition = rect.top + scrollTop;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });

    const rawSearchClinics = async (searchTerm: string) => {
      searchInput.value = searchTerm;
      const search = searchTerm.length > 2 ? searchTerm : '';
      const { data } = await query<ClinicsQuery>(clinicsBasicInfoGql, { search });
      displayedClinics.value = data.clinics?.items.map((option) => option.name);
    };

    const debouncedSearchClinics = debounce(rawSearchClinics, 500);

    const cancelSearch = () => {
      searchInput.value = '';
      displayedClinics.value = props.clinics;
    };

    return { isDropdownOpen, searchInput, displayedClinics, debouncedSearchClinics, cancelSearch };
  },
});
